import {cloneDeep, get} from 'lodash';
import {getString} from "Core/helpers/data";
import {CustomerGroupChangeRequestDataObject} from "./dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from 'Core/helpers/datetime';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {CustomerGroupChangeRequestDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new CustomerGroupChangeRequestDataObject(
		getString(result, 'id'),
		getString(result, 'type'),
		getString(result, 'fileName'),
		getDate(get(result, 'processingStartDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
	);

	return result;
}